exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".foot-notice[data-v-01266638]{background:#fdfaf9;border-radius:7px;padding:20px;margin:30px 20px 40px}.foot-notice__list[data-v-01266638]{margin:0;padding:0;font-size:12px;line-height:18px;text-align:justify}.foot-notice__list>li[data-v-01266638]{margin:0 0 1.3em;padding:0;list-style:none}.foot-notice__list>li[data-v-01266638]:last-child{margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-01266638","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/ChounDiary/partials/FootNotice.vue
// module id = rPR0
// module chunks = 0